import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import TitleConfig from "segments/desktop/core-components/title/fields-config";
import ParagraphConfig from "segments/desktop/core-components/paragraph/fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Marquee",
  fields: {
    ...ThemeConfig,
    textBoxText: {
      type: FIELD_TYPES.TEXT,
      label: "Text Box Text"
    },
    titleConfig: {
      type: FIELD_TYPES.NESTED,
      label: "Title Config",
      fields: {
        ...TitleConfig
      }
    },
    subTitleConfig: {
      type: FIELD_TYPES.NESTED,
      label: "subTitle config",
      fields: { ...ParagraphConfig }
    },
    tagsLines: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Tags Lines",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          items: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tags",
            maxLimit: 15,
            nestedConfig: {
              type: FIELD_TYPES.NESTED,
              fields: {
                text: { type: FIELD_TYPES.TEXT, label: "Text", translatable: true },
                image: { type: FIELD_TYPES.GALLERY, label: "Image" },
                backgroundColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Background Color" },
                hoverTextAndBorderColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Hover Text Color" },
                selectedTextAndBorderColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Select Text Color" }
              }
            }
          }
        }
      }
    }
  }
};
